<template>
    <div style="padding:1px;">
      <hd></hd>
      <div class="snatched">
          <img :src="expressqrcode" style="border:1px solid;padding:5px 0"/>
          <vue-canvas-poster :widthPixels="0" :painting="painting" @success="success" @fail="fail"></vue-canvas-poster>
      </div>
      <ft class="ft"></ft>
    </div>
</template>
<script>
import hd from '../../components/Header'
import ft from '../../components/Footer'
import Loading from '../../components/Loading'
import mobilefooter from '../../components/mobilefooter'
import api from '../../services/api.js'

export default {
  name: 'TrackCode',
  components: {
    hd: hd,
    mobilefooter: mobilefooter,
    ft: ft,
    Loading: Loading
  },
  data () {
    return {
      expressid:'',
      expressqrcode:'',
      painting:{},
      expresspainting:{
        width:`250px`,
        height:`350px`,
        background: '#fff',
        views: [
          {
            type: 'text',
            text: 'JoyOrders微信小程序',
            css: {
              top:'125px',
              left:'25px',
              color:'#000',
              fontSize: '20px',
              textAlign:'left',
              padding:'10px'
            }
          },
          {
            type: 'rect',
            css: 
              {
                //paintingWidth:250,
                top:'250px',
                color:'#444',
                width:'250px',
                height:'25px'
              }
            
          },
          {
            type: 'text',
            text: '长按识别，跟踪包裹 >',
            css: 
              {
                //paintingWidth:250,
                top:'255px',
                color:'#fff',
                fontSize: '13px',
                textAlign:'left',
                padding:'10px'
              }
            
          },
          {
            type: 'rect',
            css: {
              width:`100px`,
              height:`100px`,
              color:'#fff',
              borderRadius:'50px',
              right:'2px',
              top: '210px'
            }
          },
          {
            type: 'image',
            url: '',
            css: {
              width:`90px`,
              height:`90px`,
              right:'7px',
              top: '215px'
            }
          },
          {
            type: 'text',
            text: '',
            css: 
              {
                top:'290px',
                color:'#444',
                fontSize: '14px',
                textAlign:'left',
                padding:'10px',
              }
          },
          {
            type: 'text',
            text: '',
            css: 
              {
                top:'310px',
                color:'#444',
                fontSize: '14px',
                textAlign:'left',
                padding:'10px',
              }
          },
        ],
      },
    }
  },
  mounted () {
    this.expressid=this.$route.params.id?this.$route.params.id:0
    if(this.expressid)
      this.generateCode()
  },
  methods: {
    fail(err) {
      console.log('fail', err)
    },
    success(src) {
      this.expressqrcode=src;
    },
    generateCode(){
      let params={}
      params={
						page: 'pages/order/qrcodeExpress/qrcodeExpress',
						is_hyaline: true,
						scene: this.expressid
					}
          api.post(this, {
              path: 'good.php',
              data: params,
              loading: 'loading',
              api: 'create_qr_code'
          }).then((res)=>{
            this.$set(this.expresspainting.views[4], 'url', res.body);
            this.$set(this.expresspainting.views[5], 'text', `出库单号：`);
            this.$set(this.expresspainting.views[6], 'text', `${this.expressid}`);
            this.painting=JSON.parse(JSON.stringify(this.expresspainting))
          })
    },
  },
}

</script>
<style scoped lang="scss">
.snatched {
    margin: 0 auto 60px;;
    margin-top: 180px;
    // width: 914px;
    padding: 0 20%;
    text-align: center;
}
    @media screen and (max-width:1375px){
        .snatched {
            padding: 0 15%;
        }
    }
    @media screen and (max-width:1200px){
        .snatched {
            padding: 0 10%;
        }
    }
    @media screen and (max-width:1025px){
        .snatched {
            padding: 0 10px;
            margin-top: 100px;
            .toggleList {
                padding-left: 0 !important;

                .toggle{

                    width: 100%;
                    margin-bottom: 20px;
                }
            }

            .button {
                float: left;
            }

            .pool {
                margin-top: 20px;
                .poolTitle {
                    display: block;
                    width: 250px !important;
                    font-size: 14px;
                }
            }
        }
    }
    @media screen and (max-width:750px){
        .snatched {
            .pool {

                .goods  {

                    .left-content {
                        width: 100%;
                        margin-bottom: 20px;

                        .goodsList {

                            .order-des {
                                float: right !important;
                                width: 50% !important;
                            }
                        }
                    }

                    .right-operation {
                        .mobile-button {
                            width: 268px !important;
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/qrcode/trackCode.vue